import { api, apiUrl } from "../../shared/services/service";
import type { CrewOnBoardResponse } from "../models/crew-on-board.models";

export async function getCrewOnBoardReport(imoNumber: string): Promise<CrewOnBoardResponse> {
  const response = await api.get<CrewOnBoardResponse>(`${apiUrl}/crew-report`, { params: { imoNumber } });
  return response.data;
}
